document.addEventListener('DOMContentLoaded', () => {
  const waitForElement = (selector, callback, maxWait = 3000) => {
    const start = Date.now();
    const timer = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(timer);
        callback(element);
      } else if (Date.now() - start > maxWait) {
        clearInterval(timer);
        console.warn('Elemento no encontrado:', selector);
      }
    }, 100);
  };

  // Esperar al select de variante
  waitForElement('select[name="id"]', (variantSelect) => {
    // Deseleccionar opción
    variantSelect.selectedIndex = -1;

    // Desactivar botón
    const addButton = document.querySelector(
      'product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]'
    );
    if (addButton) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.style.opacity = '0.5';
      addButton.style.cursor = 'not-allowed';

      // Activar botón cuando elijan opción
      variantSelect.addEventListener('change', () => {
        addButton.removeAttribute('disabled');
        addButton.style.opacity = '';
        addButton.style.cursor = '';
      });
    }
  });
});
